export interface ZetraError {
  result: boolean;
  errorCode: string;
  meta?: { [key: string]: any };
}

const ERROR_MESSAGES: Record<string, string> = {
  // Errori sconosciuti
  ZE19999: $localize`:@@ZE19999:Errore Prisma sconosciuto`,
  ZE99999: $localize`:@@ZE99999:Errore generico sconosciuto`,
  // Prisma - Create
  ZE10000: $localize`:@@ZE10000:Errore generico in creazione`,
  ZE10001: $localize`:@@ZE10001:Record non trovato - creazione`,
  ZE10002: $localize`:@@ZE10002:Violazione vincolo univoco - creazione`,
  ZE10003: $localize`:@@ZE10003:Violazione chiave esterna - creazione`,
  ZE10004: $localize`:@@ZE10004:Violazione vincolo generico - creazione`,
  ZE10005: $localize`:@@ZE10005:Violazione relazione tra modelli - creazione`,
  ZE10006: $localize`:@@ZE10006:Record relazione non connessi - creazione`,
  ZE10007: $localize`:@@ZE10007:Conflitto in scrittura - creazione`,
  ZE10008: $localize`:@@ZE10008:Valore troppo lungo per la colonna - creazione`,
  ZE10009: $localize`:@@ZE10009:Valore non valido per il campo - creazione`,
  ZE10010: $localize`:@@ZE10010:Errore di input - creazione`,
  ZE10011: $localize`:@@ZE10011:Dati colonna inconsistenti - creazione`,
  ZE10012: $localize`:@@ZE10012:Numero troppo grande per 64bit - creazione`,
  ZE10013: $localize`:@@ZE10013:Violazione vincolo NOT NULL - creazione`,
  ZE10014: $localize`:@@ZE10014:Percorso richiesto mancante - creazione`,
  ZE10015: $localize`:@@ZE10015:Validazione query fallita - creazione`,
  ZE10016: $localize`:@@ZE10016:Errore intercettazione query - creazione`,
  ZE10017: $localize`:@@ZE10017:Parametri query superati - creazione`,
  ZE10018: $localize`:@@ZE10018:Nessun indice fulltext - creazione`,
  ZE10019: $localize`:@@ZE10019:Timeout connessione pool - creazione`,
  ZE10020: $localize`:@@ZE10020:Errore API transazione - creazione`,
  ZE10021: $localize`:@@ZE10021:Replica set MongoDB richiesta - creazione`,
  ZE10022: $localize`:@@ZE10022:Troppe connessioni - creazione`,
  ZE10023: $localize`:@@ZE10023:Query raw fallita - creazione`,
  ZE10024: $localize`:@@ZE10024:Tabella o colonna inesistente - creazione`,
  ZE10025: $localize`:@@ZE10025:Funzionalità non supportata - creazione`,
  ZE10026: $localize`:@@ZE10026:Violazione asserzione nel DB - creazione`,
  ZE10027: $localize`:@@ZE10027:Errore generico Accelerate - creazione`,
  ZE10028: $localize`:@@ZE10028:Chiave API non valida - creazione`,
  ZE10029: $localize`:@@ZE10029:Troppe richieste - creazione`,
  ZE10030: $localize`:@@ZE10030:Timeout query Accelerate - creazione`,
  ZE10031: $localize`:@@ZE10031:Parametri non validi Accelerate - creazione`,
  ZE10032: $localize`:@@ZE10032:Versione non supportata - creazione`,
  ZE10033: $localize`:@@ZE10033:Limite dimensione risposta superato - creazione`,
  ZE10034: $localize`:@@ZE10034:Progetto disabilitato - creazione`,
  ZE10090: $localize`:@@ZE10090:Errore DB sconosciuto - creazione`,
  ZE10091: $localize`:@@ZE10091:Errore critico motore DB - creazione`,
  ZE10092: $localize`:@@ZE10092:Autenticazione DB fallita - creazione`,
  ZE10093: $localize`:@@ZE10093:Server DB non raggiungibile - creazione`,
  ZE10094: $localize`:@@ZE10094:Inizializzazione connessione DB fallita - creazione`,
  ZE10095: $localize`:@@ZE10095:Dati non validi per l\'operazione - creazione`,
  ZE10096: $localize`:@@ZE10096:Errore interno del server - creazione`,
  // Prisma - Read
  ZE11000: $localize`:@@ZE11000:Errore generico in lettura`,
  ZE11001: $localize`:@@ZE11001:Record non trovato - lettura`,
  ZE11002: $localize`:@@ZE11002:Violazione vincolo univoco - lettura`,
  ZE11003: $localize`:@@ZE11003:Violazione chiave esterna - lettura`,
  ZE11004: $localize`:@@ZE11004:Violazione vincolo generico - lettura`,
  ZE11005: $localize`:@@ZE11005:Violazione relazione tra modelli - lettura`,
  ZE11006: $localize`:@@ZE11006:Record relazione non connessi - lettura`,
  ZE11007: $localize`:@@ZE11007:Conflitto in scrittura - lettura`,
  ZE11008: $localize`:@@ZE11008:Valore troppo lungo per la colonna - lettura`,
  ZE11009: $localize`:@@ZE11009:Valore non valido per il campo - lettura`,
  ZE11010: $localize`:@@ZE11010:Errore di input - lettura`,
  ZE11011: $localize`:@@ZE11011:Dati colonna inconsistenti - lettura`,
  ZE11012: $localize`:@@ZE11012:Numero troppo grande per 64bit - lettura`,
  ZE11013: $localize`:@@ZE11013:Violazione vincolo NOT NULL - lettura`,
  ZE11014: $localize`:@@ZE11014:Percorso richiesto mancante - lettura`,
  ZE11015: $localize`:@@ZE11015:Validazione query fallita - lettura`,
  ZE11016: $localize`:@@ZE11016:Errore intercettazione query - lettura`,
  ZE11017: $localize`:@@ZE11017:Parametri query superati - lettura`,
  ZE11018: $localize`:@@ZE11018:Nessun indice fulltext - lettura`,
  ZE11019: $localize`:@@ZE11019:Timeout connessione pool - lettura`,
  ZE11020: $localize`:@@ZE11020:Errore API transazione - lettura`,
  ZE11021: $localize`:@@ZE11021:Replica set MongoDB richiesta - lettura`,
  ZE11022: $localize`:@@ZE11022:Troppe connessioni - lettura`,
  ZE11023: $localize`:@@ZE11023:Query raw fallita - lettura`,
  ZE11024: $localize`:@@ZE11024:Tabella o colonna inesistente - lettura`,
  ZE11025: $localize`:@@ZE11025:Funzionalità non supportata - lettura`,
  ZE11026: $localize`:@@ZE11026:Violazione asserzione nel DB - lettura`,
  ZE11027: $localize`:@@ZE11027:Errore generico Accelerate - lettura`,
  ZE11028: $localize`:@@ZE11028:Chiave API non valida - lettura`,
  ZE11029: $localize`:@@ZE11029:Troppe richieste - lettura`,
  ZE11030: $localize`:@@ZE11030:Timeout query Accelerate - lettura`,
  ZE11031: $localize`:@@ZE11031:Parametri non validi Accelerate - lettura`,
  ZE11032: $localize`:@@ZE11032:Versione non supportata - lettura`,
  ZE11033: $localize`:@@ZE11033:Limite dimensione risposta superato - lettura`,
  ZE11034: $localize`:@@ZE11034:Progetto disabilitato - lettura`,
  ZE11090: $localize`:@@ZE11090:Errore DB sconosciuto - lettura`,
  ZE11091: $localize`:@@ZE11091:Errore critico motore DB - lettura`,
  ZE11092: $localize`:@@ZE11092:Autenticazione DB fallita - lettura`,
  ZE11093: $localize`:@@ZE11093:Server DB non raggiungibile - lettura`,
  ZE11094: $localize`:@@ZE11094:Inizializzazione connessione DB fallita - lettura`,
  ZE11095: $localize`:@@ZE11095:Dati non validi per l\'operazione - lettura`,
  ZE11096: $localize`:@@ZE11096:Errore interno del server - lettura`,
  // Prisma - Update
  ZE12000: $localize`:@@ZE12000:Errore generico in aggiornamento`,
  ZE12001: $localize`:@@ZE12001:Record non trovato - aggiornamento`,
  ZE12002: $localize`:@@ZE12002:Violazione vincolo univoco - aggiornamento`,
  ZE12003: $localize`:@@ZE12003:Violazione chiave esterna - aggiornamento`,
  ZE12004: $localize`:@@ZE12004:Violazione vincolo generico - aggiornamento`,
  ZE12005: $localize`:@@ZE12005:Violazione relazione tra modelli - aggiornamento`,
  ZE12006: $localize`:@@ZE12006:Record relazione non connessi - aggiornamento`,
  ZE12007: $localize`:@@ZE12007:Conflitto in scrittura - aggiornamento`,
  ZE12008: $localize`:@@ZE12008:Valore troppo lungo per la colonna - aggiornamento`,
  ZE12009: $localize`:@@ZE12009:Valore non valido per il campo - aggiornamento`,
  ZE12010: $localize`:@@ZE12010:Errore di input - aggiornamento`,
  ZE12011: $localize`:@@ZE12011:Dati colonna inconsistenti - aggiornamento`,
  ZE12012: $localize`:@@ZE12012:Numero troppo grande per 64bit - aggiornamento`,
  ZE12013: $localize`:@@ZE12013:Violazione vincolo NOT NULL - aggiornamento`,
  ZE12014: $localize`:@@ZE12014:Percorso richiesto mancante - aggiornamento`,
  ZE12015: $localize`:@@ZE12015:Validazione query fallita - aggiornamento`,
  ZE12016: $localize`:@@ZE12016:Errore intercettazione query - aggiornamento`,
  ZE12017: $localize`:@@ZE12017:Parametri query superati - aggiornamento`,
  ZE12018: $localize`:@@ZE12018:Nessun indice fulltext - aggiornamento`,
  ZE12019: $localize`:@@ZE12019:Timeout connessione pool - aggiornamento`,
  ZE12020: $localize`:@@ZE12020:Errore API transazione - aggiornamento`,
  ZE12021: $localize`:@@ZE12021:Replica set MongoDB richiesta - aggiornamento`,
  ZE12022: $localize`:@@ZE12022:Troppe connessioni - aggiornamento`,
  ZE12023: $localize`:@@ZE12023:Query raw fallita - aggiornamento`,
  ZE12024: $localize`:@@ZE12024:Tabella o colonna inesistente - aggiornamento`,
  ZE12025: $localize`:@@ZE12025:Funzionalità non supportata - aggiornamento`,
  ZE12026: $localize`:@@ZE12026:Violazione asserzione nel DB - aggiornamento`,
  ZE12027: $localize`:@@ZE12027:Errore generico Accelerate - aggiornamento`,
  ZE12028: $localize`:@@ZE12028:Chiave API non valida - aggiornamento`,
  ZE12029: $localize`:@@ZE12029:Troppe richieste - aggiornamento`,
  ZE12030: $localize`:@@ZE12030:Timeout query Accelerate - aggiornamento`,
  ZE12031: $localize`:@@ZE12031:Parametri non validi Accelerate - aggiornamento`,
  ZE12032: $localize`:@@ZE12032:Versione non supportata - aggiornamento`,
  ZE12033: $localize`:@@ZE12033:Limite dimensione risposta superato - aggiornamento`,
  ZE12034: $localize`:@@ZE12034:Progetto disabilitato - aggiornamento`,
  ZE12090: $localize`:@@ZE12090:Errore DB sconosciuto - aggiornamento`,
  ZE12091: $localize`:@@ZE12091:Errore critico motore DB - aggiornamento`,
  ZE12092: $localize`:@@ZE12092:Autenticazione DB fallita - aggiornamento`,
  ZE12093: $localize`:@@ZE12093:Server DB non raggiungibile - aggiornamento`,
  ZE12094: $localize`:@@ZE12094:Inizializzazione connessione DB fallita - aggiornamento`,
  ZE12095: $localize`:@@ZE12095:Dati non validi per l\'operazione - aggiornamento`,
  ZE12096: $localize`:@@ZE12096:Errore interno del server - aggiornamento`,
  //   Prisma - Delete
  ZE13000: $localize`:@@ZE13000:Errore generico in eliminazione`,
  ZE13001: $localize`:@@ZE13001:Record non trovato - eliminazione`,
  ZE13002: $localize`:@@ZE13002:Violazione vincolo univoco - eliminazione`,
  ZE13003: $localize`:@@ZE13003:Violazione chiave esterna - eliminazione`,
  ZE13004: $localize`:@@ZE13004:Violazione vincolo generico - eliminazione`,
  ZE13005: $localize`:@@ZE13005:Violazione relazione tra modelli - eliminazione`,
  ZE13006: $localize`:@@ZE13006:Record relazione non connessi - eliminazione`,
  ZE13007: $localize`:@@ZE13007:Conflitto in scrittura - eliminazione`,
  ZE13008: $localize`:@@ZE13008:Valore troppo lungo per la colonna - eliminazione`,
  ZE13009: $localize`:@@ZE13009:Valore non valido per il campo - eliminazione`,
  ZE13010: $localize`:@@ZE13010:Errore di input - eliminazione`,
  ZE13011: $localize`:@@ZE13011:Dati colonna inconsistenti - eliminazione`,
  ZE13012: $localize`:@@ZE13012:Numero troppo grande per 64bit - eliminazione`,
  ZE13013: $localize`:@@ZE13013:Violazione vincolo NOT NULL - eliminazione`,
  ZE13014: $localize`:@@ZE13014:Percorso richiesto mancante - eliminazione`,
  ZE13015: $localize`:@@ZE13015:Validazione query fallita - eliminazione`,
  ZE13016: $localize`:@@ZE13016:Errore intercettazione query - eliminazione`,
  ZE13017: $localize`:@@ZE13017:Parametri query superati - eliminazione`,
  ZE13018: $localize`:@@ZE13018:Nessun indice fulltext - eliminazione`,
  ZE13019: $localize`:@@ZE13019:Timeout connessione pool - eliminazione`,
  ZE13020: $localize`:@@ZE13020:Errore API transazione - eliminazione`,
  ZE13021: $localize`:@@ZE13021:Replica set MongoDB richiesta - eliminazione`,
  ZE13022: $localize`:@@ZE13022:Troppe connessioni - eliminazione`,
  ZE13023: $localize`:@@ZE13023:Query raw fallita - eliminazione`,
  ZE13024: $localize`:@@ZE13024:Tabella o colonna inesistente - eliminazione`,
  ZE13025: $localize`:@@ZE13025:Funzionalità non supportata - eliminazione`,
  ZE13026: $localize`:@@ZE13026:Violazione asserzione nel DB - eliminazione`,
  ZE13027: $localize`:@@ZE13027:Errore generico Accelerate - eliminazione`,
  ZE13028: $localize`:@@ZE13028:Chiave API non valida - eliminazione`,
  ZE13029: $localize`:@@ZE13029:Troppe richieste - eliminazione`,
  ZE13030: $localize`:@@ZE13030:Timeout query Accelerate - eliminazione`,
  ZE13031: $localize`:@@ZE13031:Parametri non validi Accelerate - eliminazione`,
  ZE13032: $localize`:@@ZE13032:Versione non supportata - eliminazione`,
  ZE13033: $localize`:@@ZE13033:Limite dimensione risposta superato - eliminazione`,
  ZE13034: $localize`:@@ZE13034:Progetto disabilitato - eliminazione`,
  ZE13090: $localize`:@@ZE13090:Errore DB sconosciuto - eliminazione`,
  ZE13091: $localize`:@@ZE13091:Errore critico motore DB - eliminazione`,
  ZE13092: $localize`:@@ZE13092:Autenticazione DB fallita - eliminazione`,
  ZE13093: $localize`:@@ZE13093:Server DB non raggiungibile - eliminazione`,
  ZE13094: $localize`:@@ZE13094:Inizializzazione connessione DB fallita - eliminazione`,
  ZE13095: $localize`:@@ZE13095:Dati non validi per l\'operazione - eliminazione`,
  ZE13096: $localize`:@@ZE13096:Errore interno del server - eliminazione`,
  // Logica di business - Create
  ZE20000: $localize`:@@ZE20000:Errore generico di logica - creazione`,
  ZE20001: $localize`:@@ZE20001:Numero minimo di agenti nel cluster non rispettato`,
  ZE20002: $localize`:@@ZE20002:Agenti duplicati nel cluster`,
  ZE20003: $localize`:@@ZE20003:Non si può usare sia OID value che formula`,
  ZE20004: $localize`:@@ZE20004:I dispositivi devono appartenere alla stessa azienda`,
  ZE20007: $localize`:@@ZE20007:È necessario specificare printerId o printerGroupId`,
  ZE20008: $localize`:@@ZE20008:Non si può specificare sia printerId che printerGroupId`,
  ZE20009: $localize`:@@ZE20009:Il tipo di credenziali deve essere \'password\'`,
  ZE20014: $localize`:@@ZE20014:Questa entità non può avere allegati.`,
  ZE20015: $localize`:@@ZE20015:Tipologia di allegato non supportato`,
  // Logica di business - read
  ZE21000: $localize`:@@ZE21000:Errore generico di logica - lettura`,
  // Logica di business - Update
  ZE22000: $localize`:@@ZE22000:Errore generico di logica - aggiornamento`,
  ZE22001: $localize`:@@ZE22001:Numero minimo di agenti nel cluster non rispettato`,
  ZE22002: $localize`:@@ZE22002:Agenti duplicati nel cluster`,
  ZE22003: $localize`:@@ZE22003:Non si può usare sia OID value che formula`,
  ZE22004: $localize`:@@ZE22004:I dispositivi devono appartenere alla stessa azienda`,
  ZE22005: $localize`:@@ZE22005:Una categoria non può essere genitore di se stessa`,
  ZE22006: $localize`:@@ZE22006:Non si può impostare un figlio come categoria padre`,
  ZE22008: $localize`:@@ZE22008:Non si può specificare sia printerId che printerGroupId`,
  ZE22009: $localize`:@@ZE22009:Il tipo di credenziali deve essere \'password\'`,
  // Logica di business - Delete
  ZE23000: $localize`:@@ZE23000:Errore generico di logica - eliminazione`,
  ZE23001: $localize`:@@ZE23001:Devono esserci almeno 2 agent nel cluster. Per procedere devi eliminare il cluster'`,
  ZE23010: $localize`:@@ZE23010:Non puoi eliminare te stesso`,

  // Class validator
  ZE39999: $localize`:@@ZE39999:Errore di validazione (class-validator)`,
  // Errori generici
  ZE40999: $localize`:@@ZE40999:Errore generico - creazione`,
  ZE41999: $localize`:@@ZE41999:Errore generico - lettura`,
  ZE42999: $localize`:@@ZE42999:Errore generico - aggiornamento`,
  ZE43999: $localize`:@@ZE43999:Errore generico - eliminazione`,
  // Auth / Guard
  ZE59999: $localize`:@@ZE59999:Errore di autorizzazione generico`,
  ZE59901: $localize`:@@ZE59901:Token di accesso non autorizzato`,
  ZE59902: $localize`:@@ZE59902:Impossibile identificare l\'utente`,
  ZE59903: $localize`:@@ZE59903:Impossibile identificare il ruolo dell\'utente`,
};

export const getErrorMessage = (code: string): string => {
  console.log('Error code:', code);
  return ERROR_MESSAGES[code] ?? $localize`:@@ZE99999:Errore generico sconosciuto`;
};
